import { createStyles, Theme } from '@material-ui/core';

export const styles = ({ breakpoints, palette, custom, shape }: Theme) =>
  createStyles({
    controlContainer: {
      '&:not(:first-child)': {
        marginTop: 15,
      },
      cursor: 'pointer',
      background: palette.common.white,
      padding: 5,
      paddingBottom: 20,
      paddingRight: 20,
      border: `1px solid ${custom.grey[1]}`,
      borderRadius: shape.borderRadius,
      [breakpoints.down(380)]: {
        paddingRight: 10,
      },
    },
    oldPrice: {
      marginRight: 20,
      color: custom.grey[4],
      textDecoration: 'line-through',
      textDecorationColor: custom.grey[4],
    },
    placeholder: {
      height: 262,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    error: {
      border: `4px solid ${custom.status.danger.contrastText}`,
    },
    formGroup: {
      width: '100%',
      marginBottom: 4,
    },
    newStyleFormGroup: {
      marginBottom: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      '&>div': {
        marginTop: '0 !important',
        padding: 12,
        border: `solid 1px ${custom.grey[13]}`,
        borderRadius: 8,
        '&$active': {
          backgroundColor: custom.status.warning.main,
          border: `solid 1px ${palette.primary.main}`,
        },
        '& span.MuiIconButton-root': {
          position: 'relative',
          top: 13,
          padding: 0,
          marginRight: 12,
        },
        '& label': {
          fontSize: 16,
          lineHeight: '26px',
          fontWeight: 400,
          color: custom.grey[3],
        },
        '& $checkWithPriceContainer': {
          fontWeight: 700,
          fontSize: 16,
          lineHeight: '26px',
          marginLeft: 36,
        },
        '& $installmentsDetails': {
          paddingLeft: 36,
        },
        '& $additionalInfoContainer': {
          marginLeft: 36,
          whiteSpace: 'pre',
          justifyContent: 'flex-start',
          '& > *': {
            fontSize: 14,
            color: custom.grey[3],
            lineHeight: '20px',
            width: '24%',
            marginRight: '1%',
            marginBottom: 4,
            [breakpoints.down(700)]: {
              width: '49%',
            },
          },
        },
        '& $installmentsCountSelect': {
          '&>*': {
            position: 'relative',
            top: '-30px',
            width: 98,
            '& label': {
              fontSize: 12,
              lineHeight: '18px',
              transform: 'translate(14px, -8px) scale(1)',
            },
            '& input': {
              fontWeight: 500,
            },
          },
          [breakpoints.up(420)]: {
            position: 'absolute',
            '&>*': {
              left: '133px',
              top: '-14px',
            },
          },
        },
        '& $timetable': {
          fontSize: 14,
          fontWeight: 500,
          [breakpoints.down(550)]: {
            width: '100%',
          },
        },
      },
    },
    installmentsCountSelect: {
      width: 120,
      '& [aria-label="select options"]': {
        minWidth: 'calc(100% + 4px) !important',
      },
    },
    rateChangedInfo: {
      flexBasis: '100%',
      marginTop: 5,
      marginBottom: 10,
      fontSize: 12,
      lineHeight: '18px',
      color: custom.grey[2],
    },
    withMarginLeft: {
      marginLeft: 16,
    },
    checkWithPriceContainer: {
      marginLeft: 48,
      fontSize: 19,
      lineHeight: '20px',
      color: custom.grey[3],
    },
    installmentsDetails: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      paddingLeft: 48,
      justifyContent: 'space-between',
    },
    greyBox: {
      paddingRight: 10,
      fontSize: 14,
      color: custom.grey[3],
      borderRadius: shape.borderRadius,
      width: 'fit-content',
      '&:not(:first-child)': {
        marginLeft: 15,
      },
    },
    greyBoxNew: {
      marginLeft: 0,
      paddingRight: 0,
      whiteSpace: 'nowrap',
      flexShrink: 0,
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '26px',
      color: custom.grey[17],
      '&::before': {
        content: '"\\00a0("',
      },
      '&::after': {
        content: '")"',
      },
    },
    greyBoxHighlighted: {
      paddingRight: 10,
      fontSize: 19,
      color: custom.grey[3],
      borderRadius: shape.borderRadius,
      width: 'fit-content',
      '&:not(:first-child)': {
        marginLeft: 15,
      },
    },
    greyBoxHighlightedNew: {
      color: custom.grey[3],
      borderRadius: shape.borderRadius,
      width: 'fit-content',
      whiteSpace: 'nowrap',
      flexShrink: 0,
      '&:not(:first-child)': {
        marginLeft: 15,
      },
      fontWeight: 700,
      fontSize: 16,
      lineHeight: '26px',
      paddingRight: 0,
    },
    leftColumn: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
    },
    form: {
      width: 120,
      [breakpoints.down(430)]: {
        width: 114,
      },
    },
    timetable: {
      display: 'flex',
      alignItems: 'center',
      color: palette.primary.main,
      fontSize: 13,
      fontWeight: 400,
    },
    radio: {
      fontSize: 14,
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      color: custom.grey[3],
      '& > span': {
        padding: 12,
      },
    },
    active: {
      border: `1px solid ${palette.primary.main}`,
      '& $radio': {
        color: palette.primary.main,
      },
    },
    additionalInfoContainer: {
      marginLeft: 48,
      marginTop: 14,
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        width: 'calc(33% - 10px)',
        marginRight: 10,
      },
      color: custom.grey[2],
      fontSize: 13,
      lineHeight: 2.08,
      [breakpoints.down(540)]: {
        marginTop: 5,
      },
      [breakpoints.down(800)]: {
        justifyContent: 'space-between',
        '& > *': {
          width: 135,
        },
      },
    },
  });
